import { render } from "./emptyDir.vue?vue&type=template&id=8c175982"
import script from "./emptyDir.vue?vue&type=script&lang=js"
export * from "./emptyDir.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__